module.exports = __webpack_public_path__ + "img/22.0de880a0.svg";